import { NgModule } from '@angular/core';

import { TmsLibModule } from '../tms-shared';
import {
  AddressComponent,
  AddressAddresseesComponent,
  AddressCreateModalComponent,
  AddressDetailsComponent,
  BaseCommentsComponent,
  CustomerAddressCreateModalComponent,
  PickingListComponent,
  ProformaReportComponent,
  SalesBackOrderComponent,
  SalesDepositReportComponent,
  SalesOrderBalancesComponent,
  SalesOrderConfirmationReportComponent,
  SalesOrderReportsComponent,
  SupplierAddressCreateModalComponent,
  AddressCreateAddresseesModalComponent,
  SalesOrderChartComponent,
  PurchaseInvoiceChartComponent,
  PurchaseOrderChartComponent,
  SalesInvoiceChartComponent,
} from './components';

const addressComponents = [
  AddressComponent,
  AddressAddresseesComponent,
  AddressCreateAddresseesModalComponent,
  AddressCreateModalComponent,
  AddressDetailsComponent,
  CustomerAddressCreateModalComponent,
  SupplierAddressCreateModalComponent,
];

const chartComponents = [
  PurchaseInvoiceChartComponent,
  PurchaseOrderChartComponent,
  SalesInvoiceChartComponent,
  SalesOrderChartComponent,
];

const salesComponents = [
  PickingListComponent,
  ProformaReportComponent,
  SalesBackOrderComponent,
  SalesDepositReportComponent,
  SalesOrderBalancesComponent,
  SalesOrderConfirmationReportComponent,
  SalesOrderReportsComponent,
];

const components = [...addressComponents, BaseCommentsComponent, chartComponents, salesComponents];

@NgModule({
  imports: [TmsLibModule],
  declarations: components,
  exports: [TmsLibModule, ...components],
})
export class TmsAppSharedModule {}
